var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: _vm.height ? { height: _vm.height } : null },
    [
      _c(
        "label",
        {
          staticClass: "fntP",
          class: _vm.isLeft ? "NCAcmi_cont01_file01" : "NCAcmi_cont01_file02",
          style: _vm.isLeft && _vm.hideBtn ? { display: "block" } : null
        },
        [
          _c(
            "em",
            {
              staticClass: "disIb",
              class: {
                moOnly: !_vm.isLeft,
                padBS: _vm.isLeft && _vm.hideBtn
              }
            },
            [
              _vm._v(_vm._s(_vm.question.title) + " "),
              _vm.question.required === "TRUE"
                ? _c("span", { staticClass: "ico-must-astar" })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm._t("inner"),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "NCAcmi_fileBtn",
              class: { disabled: _vm.disabled || _vm.existFileData },
              style: [
                _vm.hideBtn ? { display: "none" } : null,
                _vm.disabled || _vm.existFileData ? null : { cursor: "pointer" }
              ],
              on: { click: _vm.clickUploadButton }
            },
            [_vm._v("파일 업로드")]
          )
        ],
        2
      ),
      _vm._v(" "),
      !_vm.existFileData
        ? _c("input", {
            ref: "attachment",
            staticStyle: { display: "none" },
            attrs: {
              type: "file",
              accept: ".png, .jpg, .pdf",
              name: "file" + _vm.resIdx + "_" + _vm.question.sq_code
            },
            on: { change: _vm.uploadAttachment }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "posRe",
          style: _vm.hideBtn ? { display: "none" } : null
        },
        [
          _c(
            "label",
            {
              staticClass: "NCAcmi_cont01_file01 marTS NCAcmiFile_remove",
              on: { click: _vm.downloadFile }
            },
            [
              _c("input", {
                staticClass: "file_download",
                style: _vm.existFileData ? { cursor: "pointer" } : null,
                attrs: { type: "text", title: _vm.originalName, disabled: "" },
                domProps: { value: _vm.originalName }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "posAb",
                  staticStyle: { right: "0", top: "6px", background: "none" },
                  style:
                    !_vm.existFileData || _vm.disabled
                      ? { display: "none" }
                      : null,
                  on: { click: _vm.deleteAttachment }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../images/btn_close.png"),
                      alt: "파일 삭제 버튼"
                    }
                  })
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm._t("outer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-148ceef5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148ceef5","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyAttachment.vue
// module id = null
// module chunks = 